import React from "react";
import { useTable } from "../../Components/useTable";

const WithdrawPayment = () => {
  const type = "Withdraw Payment Methods";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    // { id: "id", numeric: false, label: "ID" },
    { id: "name", numeric: false, label: "Name" },
    { id: "pictureUrl", numeric: false, label: "Image" },
    { id: "feePercentage", numeric: false, label: "Fee Percentage" },
    { id: "arrivalInHours", numeric: false, label: "Arrival In Hours" },
    { id: "type", numeric: false, label: "Bank Type" },
    { id: "created", numeric: false, label: "Created at" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default WithdrawPayment;
